import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@node-space/ui-components'
import { ExternalLink } from 'components/ExternalLink/ExternalLink'
import { PageHeader } from 'components/header/PageHeader'
import { RewardsHeaderActions } from './RewardsHeaderActions'

interface RewardsPageHeaderProps {
  description?: string
  showWithdrawButton?: boolean
  showDepositButton?: boolean
}

export const RewardsPageHeader = ({
  description,
  showWithdrawButton = true,
  showDepositButton = true,
}: RewardsPageHeaderProps) => {
  const { t } = useTranslation()

  return (
    <PageHeader
      description={
        <Box className="text-foreground-subdued text-body-regular">
          {description || t('rewards.description')}{' '}
          <ExternalLink href="https://docs.bvnk.com/docs/introduction" target="_blank">
            {t('rewards.descriptionLink')}
          </ExternalLink>
        </Box>
      }
      renderRightSection={
        <RewardsHeaderActions
          showWithdrawButton={showWithdrawButton}
          showDepositButton={showDepositButton}
        />
      }
    />
  )
}
